import {useState,useEffect,useRef} from 'react'
import {Stack, Button,InputGroup, FormControl,Modal, Image, Dropdown, Spinner,Row, Col, Offcanvas, Form} from 'react-bootstrap'
import { ToastContainer, toast } from 'react-toastify';
import axios from "axios"
import '../styles/heybot.css'
import {ReactComponent as SendIcon} from '../assets/send.svg'
import {ReactComponent as GoogleIcon} from '../assets/google.svg'
import { useNavigate } from "react-router-dom";
import { ReactComponent as QuestionIcon } from "../assets/question-mark.svg";
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { ReactComponent as DiscordIcon } from "../assets/discord.svg";
import logoImage from '../assets/privategpt.png'

function PrivateGPT() {
    const [showBanner, setShowBanner] = useState(false);
    const navigate = useNavigate()
    document.title = "PrivateGPT"
	function gotoPrivateGPT() {
		window.open("https://github.com/SamurAIGPT/privateGPT", "_blank")
	}
	useEffect(() => {
		//window.setTimeout(()=>setShowBanner(true),30000)
    }, [])		
    
    return (
        <div class=" d-flex justify-content-center">
            <div className="bot-container">
                <Stack className="text-center mx-2 mx-md-5 px-md-5 py-4 vh-100 align-items-center" gap={4}>
                    <Stack className="p-3" direction="horizontal">
                        <h3 className="fw-bold">
						<Image className="heybot-logo" src={logoImage}/>
                            PrivateGPT
                        </h3>
                    </Stack>
                    
					<h5 className="mt-5 pt-5">PrivateGPT - Chat with your data securely without privacy issue</h5>
					<Button className="option-buttons align-self-center" onClick={()=>gotoPrivateGPT()}> Go to PrivateGPT</Button>
                    
                </Stack>
            </div>
            <ToastContainer />	
            <Modal className="banner-modal" centered show={showBanner} onHide={()=>setShowBanner(false)}>
                <Modal.Body className="p-5 position-relative">
                <b style={{cursor:'pointer'}} onClick={()=>setShowBanner(false)} className="position-absolute top-0 end-0 me-4 mt-2">X</b>
                <Stack className="align-items-center" gap={3}>
                    <a href="https://www.producthunt.com/posts/privategpt?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-privategpt" target="_blank"><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=395718&theme=light" alt="PrivateGPT - Your&#0032;Offline&#0032;Personal&#0032;AI&#0032;Assistant | Product Hunt" style="width: 250px; height: 54px;" width="250" height="54" /></a>
                </Stack>
                </Modal.Body>
            </Modal>
		
        </div>
    )
}

export default PrivateGPT